import React, { useEffect, useState } from "react";
import { useGetPreferredShot } from "./hooks/use-get-preferred-shot";
import { getUneditedFallback } from "./lib/thumbnailData";
import { ImagePopout } from "./image-popout";

import "./image-stream.scss";

const Thumbnail = ({ photoKey, hasEditedShots, reference, referenceProductImages, shipmentKey, shipmentProductKey, disablePopout, ...props }) => {
    const [imageUris, setImageUris] = useState({ small: "/images/loader.svg", normal: "/images/noimage.jpg" });
    const size = props.size || "thumbnail";
    const coderType = props.coderTypeLabel ? `_${props.coderTypeLabel}` : "";
    const { data: preferredImageUrl, isSuccess } = useGetPreferredShot(photoKey, hasEditedShots, reference);

    useEffect(() => {
        if (!photoKey) {
            return;
        }

        if (reference && referenceProductImages) {
            const referenceImageUrl = getUneditedFallback(referenceProductImages, hasEditedShots);

            return setImageUris(
                referenceImageUrl
                    ? { small: referenceImageUrl.small, normal: referenceImageUrl.normal }
                    : { small: "/images/noimage.jpg", normal: "/images/noimage.jpg" }
            );
        }

        if (isSuccess) {
            setImageUris(
                preferredImageUrl
                    ? { small: preferredImageUrl.small, normal: preferredImageUrl.normal }
                    : { small: "/images/noimage.jpg", normal: "/images/noimage.jpg" }
            );
        }
    }, [photoKey, preferredImageUrl, isSuccess, reference, referenceProductImages]);

    if (disablePopout) {
        return (
            <div className={`image-stream -${size}`}>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/image-browser/${shipmentKey}/${shipmentProductKey}`}
                >
                    <img
                        id={photoKey}
                        src={imageUris.small}
                        alt="Preferred"
                    />
                </a>
            </div>
        );
    }

    return (
        <div className={`image-stream -${size}`}>
            <ImagePopout
                photoKey={`${photoKey}${coderType}`}
                imageUris={imageUris}
                alt="Preferred"
                shipmentKey={shipmentKey}
                shipmentProductKey={shipmentProductKey}
                isInModal={props.isInModal}
            />
        </div>
    );
};

export default Thumbnail;
